import { Box, Button, DialogActions, IconButton, Typography } from "@mui/material"
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { imgurl } from "../../pages/Utils/Baseurl";
import MaterialButton from "../../components/MaterialButton";

const Payslip = ({ handleFileUpload, handleupdatepayslip, recruitmentdata, handlePay, setOpen, setrecruitmentdata }) => {
  return (
    <>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <Typography
          sx={{
            marginRight: "12px",
            fontWeight: 500,
            fontSize: "1.1rem",
          }}
        >
          PaySlip :
        </Typography>

        <Typography
          sx={{
            marginRight: "12px",
            fontWeight: 500,
            fontSize: "1.1rem",
          }}
        >
          {recruitmentdata?.payslipname}
        </Typography>
        {recruitmentdata.payslipurl?.length > 3 && (
          <IconButton
            onClick={() => {
              window.open(imgurl + "/" + recruitmentdata.payslipurl);
            }}
          >
            <VisibilityIcon />
          </IconButton>
        )}
      </Box>
      <Box>
        <input
          type="file"
          id="fileUpload"
          style={{ display: "none" }}
          onChange={(e) => handleFileUpload(e.target.files)}
        />

        {/* Custom Upload Button */}
        <label htmlFor="fileUpload">
          <Button
            variant="contained"
            component="span"
            startIcon={<CloudUploadIcon />}
            sx={{
              textTransform: "none",
              fontSize: "1rem",
              padding: "12px 24px",
              borderRadius: "12px",
              backgroundColor: "#4CAF50",
              color: "#FFF",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
              "&:hover": { backgroundColor: "#388E3C" },
            }}
          >
            Upload PaySlip
          </Button>
        </label>
      </Box>

      <DialogActions sx={{ justifyContent: "center" }}>
        <MaterialButton
          onClick={() => setOpen(false)}
          variant="gradient"
          color="dark"
        >
          Cancel
        </MaterialButton>
        {recruitmentdata?.recruitmentprocessid ? (
          <MaterialButton
            onClick={handleupdatepayslip}
            variant="gradient"
            color="dark"
          >
            Update
          </MaterialButton>
        ) : (
          <MaterialButton

            onClick={handlePay}
            variant="gradient"
            color="dark"
          >
            Submit
          </MaterialButton>
        )}
      </DialogActions>
    </>
  )
}
export default Payslip